// extracted by mini-css-extract-plugin
export const upload = "upload-module--upload--nluwd";
export const profileImage = "upload-module--profileImage--5ycXO";
export const btnUpload = "upload-module--btnUpload--lXHWj";
export const inputFile = "upload-module--inputFile--PcuRs";